import { z } from 'zod/v4';

export const getCollectionMappingsQuerySchema = z.object({
  limit: z.coerce.number().min(1).max(100).optional().default(25),
  offset: z.coerce.number().min(0).optional().default(0),
  search: z.string().optional(),
});

export const getCollectionsForItemSchema = z.object({
  itemId: z.string().uuid(),
});

export const platformMappingOverrideSchema = z.object({
  collectionId: z.string().uuid(),
  itemId: z.string().uuid(),
  sourceUom: z.string().max(50).optional(),
  conversionFactor: z.string().optional(),
  isActive: z.boolean().optional(),
});

export const platformCollectionOverrideSchema = z.object({
  name: z.string().min(1).optional(),
  targetUom: z.string().min(1).optional(),
  isActive: z.boolean().optional(),
});

export const orgCollectionOverrideSchema = z.object({
  name: z.string().min(1).optional(),
  targetUom: z.string().min(1).optional(),
  isActive: z.boolean().optional(),
});
